class Clock {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.setClock();
  }

  unmount() {
    this.ui = {};
  }

  bindUI() {
    this.ui = {};
    this.ui.$clocks = this.element.querySelectorAll('[data-ref="clock-item"]');
  }

  setTimeZone(zone) {
    const currentTime = new Date().toLocaleTimeString('en-US', {
      timeZone: zone,
      hour: '2-digit',
      minute: '2-digit',
    });

    return currentTime;
  }

  setClock() {
    this.ui.$clocks.forEach((clock) => {
      const localTime = clock.title;
      const getTime = this.setTimeZone(localTime);
      const time = clock.closest('[data-ref="clock-parent"]').querySelector('[data-ref="clock-time"]');

      // Get Hour and Minute
      const hour = getTime.slice(0, 2);
      const minute = getTime.slice(3, 5);

      // clock
      const deg = 6;
      const hourDegree = (hour * 30) + (minute / 2) + 90;
      const minuteDegree = minute * deg + 90;

      time.innerHTML = getTime;

      // z-tranform hour
      clock.querySelector('[data-ref="clock-hour"]').style.transform = `rotateZ(${
        hourDegree
      }deg)`;

      // z-transform minute
      clock.querySelector(
        '[data-ref="clock-minute"]'
      ).style.transform = `rotateZ(${minuteDegree}deg)`;
    });
  }
}

export default Clock;
